import { ItemTrackerProductsStocksMappingModel } from "./item-tracker-products-stocks-mapping-model";

export class InsertOrUpdateProductsStocksMappingModel {
    public ItemTrackerProductsStocksMappingModels:ItemTrackerProductsStocksMappingModel[];
}
